import { config } from "src/stateManagement/redux/configVar";
import { formatDateToYYYYMMDD } from "./formatDates";

export const getDailySummaryReportAlone = async (reportId: string, reportCode: string, startDate: Date | string, endDate: Date | string, projectId: string) => {
    try {

        const serverUrl = config.serverUrl

        let token = localStorage.getItem("authToken");

        if (!token) {
            return;
        }


        const headers: any = {
            "Content-Type": "application/json",
            authorization: `${token}`,
            report_id: reportId,
            report_code: reportCode,
            start_date: formatDateToYYYYMMDD(startDate),
            end_date: formatDateToYYYYMMDD(endDate),
        }

        if (projectId) {
            headers["project_id"] = projectId;
        }


        const response = await fetch(`${serverUrl}/api/reports/getDailySummaryReport`, {
            method: "GET",
            headers
        });


        if (response?.status === 401) {
            return;
        }

        if (response?.status !== 200 && response?.status !== 201) {
            return;
        }

        const data = await response.json();

        return data;
    } catch (error) {
        console.log({ error });
    }
}

export const getTaskDataByid = async (taskId: string) => {
    try {

        const serverUrl = config.serverUrl

        let token = localStorage.getItem("authToken");

        if (!token) {
            return;
        }


        const headers: any = {
            "Content-Type": "application/json",
            authorization: `${token}`,
            planningActivityId: taskId
        }

        const response = await fetch(`${serverUrl}/api/planning/getPlanningActivityById`, {
            method: "GET",
            headers
        });


        if (response?.status === 401) {
            return;
        }

        if (response?.status !== 200 && response?.status !== 201) {
            return;
        }

        const data = await response.json();

        return data;
    } catch (error) {
        console.log({ error });
    }
}

export const getListOfUsers = async () => {
    try {

        const serverUrl = config.serverUrl

        let token = localStorage.getItem("authToken");

        if (!token) {
            return;
        }

        const headers: any = {
            "Content-Type": "application/json",
            authorization: `${token}`,
        }

        const response = await fetch(`${serverUrl}/api/shared/listOfUsers`, {
            method: "GET",
            headers
        });

        if (response?.status === 401) {
            return;
        }

        if (response?.status !== 200 && response?.status !== 201) {
            return;
        }

        const data = await response.json();

        return data;
    } catch (error) {
        console.log({ error });
    }
}

export const getListForConfigTask = async () => {
    try {

        const serverUrl = config.serverUrl

        let token = localStorage.getItem("authToken");

        if (!token) {
            return;
        }

        const headers: any = {
            "Content-Type": "application/json",
            authorization: `${token}`,
        }

        const response = await fetch(`${serverUrl}/api/shared/getListForPlanningTask`, {
            method: "GET",
            headers
        });

        if (response?.status === 401) {
            return;
        }

        if (response?.status !== 200 && response?.status !== 201) {
            return;
        }

        const data = await response.json();

        return data;
    } catch (error) {
        console.log({ error });
    }
}

export const getListOfLocationsByProject = async (projectId?: string) => {
    try {

        const serverUrl = config.serverUrl

        let token = localStorage.getItem("authToken");

        if (!token) {
            return;
        }

        const headers: any = {
            "Content-Type": "application/json",
            authorization: `${token}`,
        }

        if (projectId) {
            headers["projectId"] = projectId;
        }

        const response = await fetch(`${serverUrl}/api/projects/getLocations`, {
            method: "GET",
            headers
        });

        if (response?.status === 401) {
            return;
        }

        if (response?.status !== 200 && response?.status !== 201) {
            return;
        }

        const data = await response.json();

        return data;
    } catch (error) {
        console.log({ error });
    }
}

export const getOriginFlowByModule = async (module: string) => {
    try {

        const serverUrl = config.serverUrl

        let token = localStorage.getItem("authToken");

        if (!token) {
            return;
        }

        const headers: any = {
            "Content-Type": "application/json",
            authorization: `${token}`,
            uploadModule: module,
        }

        const response = await fetch(`${serverUrl}/api/shared/getOriginFlowByUploadModule`, {
            method: "GET",
            headers
        });

        if (response?.status === 401) {
            return;
        }

        if (response?.status !== 200 && response?.status !== 201) {
            return;
        }

        const data = await response.json();

        return data;
    } catch (error) {
        console.log({ error });
    }
}

export const getFormValidations = async (code: string, fromModuleVersion: string) => {
    try {

        const serverUrl = config.serverUrl

        let token = localStorage.getItem("authToken");

        if (!token) {
            return;
        }

        const headers: any = {
            "Content-Type": "application/json",
            authorization: `${token}`,
            formCode: code,
            fromModuleVersion,
        }

        const response = await fetch(`${serverUrl}/api/shared/getFormValidations`, {
            method: "GET",
            headers
        });

        if (response?.status === 401) {
            return;
        }

        if (response?.status !== 200 && response?.status !== 201) {
            return;
        }

        const data = await response.json();

        return data;
    } catch (error) {
        console.log({ error });
    }
}

export const getGroupAssignedConfig = async () => {
    try {

        const serverUrl = config.serverUrl

        let token = localStorage.getItem("authToken");

        if (!token) {
            return;
        }

        const headers: any = {
            "Content-Type": "application/json",
            authorization: `${token}`,
        }

        const response = await fetch(`${serverUrl}/api/shared/getGroupAssignedConfig`, {
            method: "GET",
            headers
        });

        if (response?.status === 401) {
            return;
        }

        if (response?.status !== 200 && response?.status !== 201) {
            return;
        }

        const data = await response.json();

        return data;
    } catch (error) {
        console.log({ error });
    }
}

export const getPendingRequirementsByDate = async (startDate: Date | string, endDate: Date | string, projectId?: string) => {
    try {

        const serverUrl = config.serverUrl

        let token = localStorage.getItem("authToken");

        if (!token) {
            return;
        }

        const headers: any = {
            "Content-Type": "application/json",
            authorization: `${token}`,
            start_date: formatDateToYYYYMMDD(startDate),
            end_date: formatDateToYYYYMMDD(endDate),
        }

        if (projectId) {
            headers["project_id"] = projectId;
        }


        const response = await fetch(`${serverUrl}/api/reports/getActivesRequirementsReport`, {
            method: "GET",
            headers
        });


        if (response?.status === 401) {
            return;
        }

        if (response?.status !== 200 && response?.status !== 201) {
            return;
        }

        const data = await response.json();

        return data;
    } catch (error) {
        console.log({ error });
    }
}

export const getAnalyzedByDate = async (startDate: Date | string, endDate: Date | string, projectId?: string) => {
    try {

        const serverUrl = config.serverUrl

        let token = localStorage.getItem("authToken");

        if (!token) {
            return;
        }

        const headers: any = {
            "Content-Type": "application/json",
            authorization: `${token}`,
            start_date: formatDateToYYYYMMDD(startDate),
            end_date: formatDateToYYYYMMDD(endDate),
        }

        if (projectId) {
            headers["project_id"] = projectId;
        }


        const response = await fetch(`${serverUrl}/api/reports/getAnalysisReport`, {
            method: "GET",
            headers
        });


        if (response?.status === 401) {
            return;
        }

        if (response?.status !== 200 && response?.status !== 201) {
            return;
        }

        const data = await response.json();

        return data;
    } catch (error) {
        console.log({ error });
    }
}

export const getDashboardDataProfileByMethod = async (method?: string) => {
    try {

        const serverUrl = config.serverUrl

        let token = localStorage.getItem("authToken");

        if (!token) {
            return;
        }

        const headers: any = {
            "Content-Type": "application/json",
            authorization: `${token}`,
            method,
        }

        const response = await fetch(`${serverUrl}/api/operations/getAllDashboardProfilesByMethod`, {
            method: "GET",
            headers
        });


        if (response?.status === 401) {
            return;
        }

        if (response?.status !== 200 && response?.status !== 201) {
            return;
        }

        const data = await response.json();

        return data;
    } catch (error) {
        console.log({ error });
    }
}

export const getTagList = async () => {

    try {

        const serverUrl = config.serverUrl

        let token = localStorage.getItem("authToken");

        if (!token) {
            return;
        }

        const response = await fetch(
            `${serverUrl}/api/configuration/get-tags-list`,
            {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    authorization: `${token}`,
                },
            }
        );

        if (response?.status === 401) {
            return;
        }

        if (response?.status !== 200 && response?.status !== 201) {
            return;
        }

        const data = await response.json();

        return data;

    } catch (error) {
        console.log({ error });
    }


}

export const getTagLgetListOfOptimizationActivitiesist = async (body:any) => {

    try {

        const serverUrl = config.serverUrl

        let token = localStorage.getItem("authToken");

        if (!token) {
            return;
        }

        const response = await fetch(
            `${serverUrl}/api/operations/getListOfOptimizationActivities`,
            {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    authorization: `${token}`,
                },
                body: JSON.stringify(body)
            }
        );

        if (response?.status === 401) {
            return;
        }

        if (response?.status !== 200 && response?.status !== 201) {
            return;
        }

        const data = await response.json();

        return data;

    } catch (error) {
        console.log({ error });
    }


}